
export default function Features() {
  const features = [
    {
      icon: 'ri-book-open-line',
      title: '매주 철학 자료',
      description: '매주 새로운 철학 콘텐츠로 지혜를 쌓아가세요',
      image: 'https://public.readdy.ai/ai/img_res/04695362220fa67261336f851189eb06.jpg'
    },
    {
      icon: 'ri-lightbulb-line',
      title: '솔로몬의 지혜',
      description: '고대 철학자들의 지혜를 현대적으로 해석하여 전달',
      image: 'https://readdy.ai/api/search-image?query=Ancient%20wisdom%20symbols%20and%20scrolls%20with%20golden%20light%2C%20representing%20Solomon%20wisdom%20and%20philosophy%2C%20mystical%20educational%20atmosphere&width=400&height=300&seq=feature2&orientation=landscape'
    },
    {
      icon: 'ri-team-line',
      title: '리더십 개발',
      description: '철학적 사고를 통한 진정한 리더십 함양',
      image: 'https://readdy.ai/api/search-image?query=Young%20Korean%20students%20in%20leadership%20discussion%20circle%2C%20collaborative%20learning%20environment%2C%20bright%20classroom%20setting&width=400&height=300&seq=feature3&orientation=landscape'
    },
    {
      icon: 'ri-heart-line',
      title: '행복의 열쇠',
      description: '복잡하지 않은 진정한 행복을 찾는 방법',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Korean%20teenagers%20smiling%20and%20studying%20together%2C%20joyful%20learning%20atmosphere%2C%20bright%20and%20positive%20educational%20environment&width=400&height=300&seq=feature4&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            세상을 한눈에 꿰뚫어 보는 철학 공부
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            <span className="block mb-2">"어디에도 내 집처럼 따뜻한 곳이 없으니</span>
            <span className="block mb-4">가정의 소중함을 알라"</span>
            <span className="block font-medium">이런 깊은 철학적 사고를 통해 놀라운 지혜를 얻어보세요</span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="mb-4">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full h-48 object-cover object-top rounded-xl mb-4"
                />
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className={`${feature.icon} text-2xl text-blue-600`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              매주 전송되는 특별한 자료
            </h3>
            <p className="text-gray-600 mb-6 max-w-3xl mx-auto leading-relaxed">
              <span className="block mb-2">이 전송 자료는 회원들에게 매주 전송되며,</span>
              <span className="block mb-2">내용은 매주 새로운 내용으로 업데이트됩니다.</span>
              <span className="block font-medium">꾸준히 보시면 놀라운 지혜를 얻게 될 것입니다.</span>
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-calendar-line text-2xl text-green-600"></i>
                </div>
                <h4 className="font-semibold text-gray-800">매주 정기 발송</h4>
                <p className="text-sm text-gray-600">1주일에 한 번씩 새로운 철학 자료</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-refresh-line text-2xl text-purple-600"></i>
                </div>
                <h4 className="font-semibold text-gray-800">매주 새로운 내용</h4>
                <p className="text-sm text-gray-600">지속적으로 업데이트되는 콘텐츠</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-star-line text-2xl text-yellow-600"></i>
                </div>
                <h4 className="font-semibold text-gray-800">놀라운 지혜</h4>
                <p className="text-sm text-gray-600">참여할수록 얻는 깊은 통찰</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
